// extracted by mini-css-extract-plugin
module.exports = {"default":"Switch_default__1sxPp","off":"Switch_off__3LegB Switch_default__1sxPp"};